module.exports = __webpack_public_path__ + "static/media/spinner.6a685536.svg";